// src/pages/Main/frontPage.js

import React from "react";
import { Container } from "react-bootstrap";
import Stage from "pages/Main/stage";
import "pages/Main/frontPages.css";

export const PageHead = ({ eyebrow, title, text }) => (
  <Stage kind="head">
    <Container>
      <span className="fp-eyebrow">{eyebrow}</span>
      <h1 className="fp-page-title">{title}</h1>
      <p className="fp-page-sub">{text}</p>
    </Container>
  </Stage>
);

// Without a title the eyebrow names the section, so a hidden h2 carries it and the visible one is not read twice.
export const SectionTitle = ({ eyebrow, title, text }) => (
  <div className="fp-section-title">
    {!title && <h2 className="sr-only">{eyebrow}</h2>}
    {eyebrow && <span className="fp-eyebrow" aria-hidden={title ? undefined : "true"}>{eyebrow}</span>}
    {title && <h2>{title}</h2>}
    <p>{text}</p>
  </div>
);
